import { useFormik } from "formik";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCategory,
  getSubCategory,
} from "../../store/AsyncMethods/CategoryMethod";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { RESET_ERROR } from "../../store/Types/AuthTypes";
import { toast } from "react-toastify";

import {
  addProduct,
  getOptionValues,
  getProducts,
  getVarientOption,
  getspecificProduct,
  updateProduct,
  getProductBrands,
  addProductBrand,
  getAllProductImages,
} from "../../store/AsyncMethods/ProductMethod";
import AddProductTable from "./AddProductTable";
import AddVarientForm from "./AddVarientForm";
import AddProductForm from "./AddProductForm";
import { RESET_SPECIFIC_PRODUCT } from "../../store/Types/ProductTypes";
import ManagePicture from "./ManagePicture";
import ProductImage from "./ProductImage";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import Barcode from "react-barcode";
import { FileUpload } from "primereact/fileupload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import MediaCenterModal from "../Productsf/add-product/sections/MediaCenterModal";

export default function AddProduct() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { productId } = useParams();
  const location = useLocation();

  const [showVarientForm, setShowVarientForm] = useState(false);
  const [showPackagingInfo, setShowPackagingInfo] = useState(false);
  const [isMediaCenterOpen, setIsMediaCenterOpen] = useState(false);
  const [mediaImages, setMediaImages] = useState([]);
  const quillRef = useRef(null);

  const { error, user } = useSelector((state) => state.AuthReducer);
  const { varientOptions, specificProduct, products } = useSelector(
    (state) => state.ProductReducer
  );

  const { subCategories } = useSelector((state) => state.CategoryReducer);

  const [filterSubCategories, setFilterSubCategories] = useState([]);

  const [validateVarient, setValidateVarient] = useState(false);

  const varientOptionsValidation = {
    properties: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required("Property name is required"),
        value: Yup.string().required("Property value is required"),
      })
    ),
    purchasePrice: Yup.number().required("Purchase Price is required"),
    price: Yup.number().required("Price is required"),
    discount: Yup.number().required("Discount is required"),
    shipment_charges: Yup.number().min(
      0,
      "Shipment charges cannot be negative"
    ),
  };

  const [editingVarient, setEditingVarient] = useState(null);

  const editVarient = (varient) => {
    setEditingVarient(varient);
    setShowVarientForm(true);
  };

  useEffect(() => {
    if (specificProduct) {
      formik.setValues({
        title: specificProduct.title || "",
        titleUrdu: specificProduct.title_urdu || "",
        articleName: specificProduct.article_name || "",
        description: specificProduct.description || "",
        highlights: specificProduct.highlights || "",
        status: specificProduct.is_active === 1 ? true : false,
        isFeatured: specificProduct.is_featured === 1 ? true : false,
        isCollection: specificProduct.is_collection === 1 ? true : false,
        purchasePrice: specificProduct.purchase_price || 0,
        price: specificProduct.price || 0,
        discount: specificProduct.discount || 0,
        subCategoryId: specificProduct.sub_category_id || "",
        categoryId: specificProduct.category_id || "",
        samePrice: specificProduct.is_same_price === 1 ? true : false,
        samePurchasePrice:
          specificProduct.is_same_purchase_price === 1 ? true : false,
        sameDiscount: specificProduct.is_same_discount === 1 ? true : false,
        userId: user.id,
        varients: specificProduct.varients || [],
        varient: {
          quantity: 0,
          purchasePrice: specificProduct.purchase_price || 0,
          price: specificProduct.price || 0,
          discount: specificProduct.discount || 0,
          shipment_charges: 0,
        },
        images: [],
        allImages: specificProduct.all_images || [],
        // Add for video support
        productVideo: specificProduct.product_video || null,
        productYoutubeLink: specificProduct.product_youtube_link || "",
        videoOption: specificProduct.product_video
          ? "upload"
          : specificProduct.product_youtube_link
          ? "youtube"
          : "upload",
        // Add for brand and what's in box
        brand: specificProduct.brand || "",
        whatsInBox: specificProduct.whats_in_box || "",
        // Add for weight, dimensions, dangerous goods
        productWeightValue: specificProduct.product_weight_value || "",
        productWeightUnit: specificProduct.product_weight_unit || "kg",
        packageLength: specificProduct.package_length || "",
        packageWidth: specificProduct.package_width || "",
        packageHeight: specificProduct.package_height || "",
        dangerousGoods: specificProduct.dangerous_goods || "none",
        warrantyType: specificProduct.warranty_type || "no",
        // Add for price, stock, sku, variants
        standardPrice: specificProduct.standard_price || "",
        specialPrice: specificProduct.special_price || "",
        promoStartDate: specificProduct.promo_start_date
          ? new Date(specificProduct.promo_start_date)
          : null,
        promoEndDate: specificProduct.promo_end_date
          ? new Date(specificProduct.promo_end_date)
          : null,
        stockQuantity: specificProduct.stock_quantity || "",
        sellerSku: specificProduct.seller_sku || "",
        showOnFrontpage: specificProduct.show_on_frontpage === 1 ? true : false,
        variants: specificProduct.variants || [],
      });
    }
  }, [specificProduct]);

  const formik = useFormik({
    initialValues: {
      title: specificProduct ? specificProduct.title : "",
      titleUrdu: specificProduct ? specificProduct.title_urdu : "",
      articleName: specificProduct ? specificProduct.article_name : "",
      description: specificProduct ? specificProduct.description : "",
      highlights: specificProduct ? specificProduct.highlights : "",
      status: specificProduct
        ? specificProduct.is_active === 1
          ? true
          : false
        : true,
      isFeatured: specificProduct
        ? specificProduct.is_featured === 1
          ? true
          : false
        : false,
      isCollection: specificProduct
        ? specificProduct.is_collection === 1
          ? true
          : false
        : false,
      purchasePrice: specificProduct ? specificProduct.purchase_price : 0,
      price: specificProduct ? specificProduct.price : 0,
      discount: specificProduct ? specificProduct.discount : 0,
      subCategoryId: specificProduct ? specificProduct.sub_category_id : "",
      categoryId: specificProduct ? specificProduct.category_id : "",
      samePrice: specificProduct
        ? specificProduct.is_same_price === 1
          ? true
          : false
        : true,
      samePurchasePrice: specificProduct
        ? specificProduct.is_same_purchase_price === 1
          ? true
          : false
        : true,
      sameDiscount: specificProduct
        ? specificProduct.is_same_discount === 1
          ? true
          : false
        : true,
      showOnFrontpage: specificProduct
        ? specificProduct.show_on_frontpage === 1
          ? true
          : false
        : false,
      userId: user.id,
      varients: specificProduct ? specificProduct.varients : [],
      varient: {
        quantity: 0,
        purchasePrice: 0,
        price: 0,
        discount: 0,
        shipment_charges: 0,
      },
      images: [],
      allImages: specificProduct ? specificProduct.all_images : [],
      // Add for video support
      productVideo: null,
      productYoutubeLink: "",
      videoOption: "upload",
      // Add for brand and what's in box
      brand: "",
      whatsInBox: "",
      // Add for weight, dimensions, dangerous goods
      productWeightValue: "",
      productWeightUnit: "kg",
      packageLength: "",
      packageWidth: "",
      packageHeight: "",
      dangerousGoods: "none",
      warrantyType: "no",
      // Add for price, stock, sku, variants
      standardPrice: "",
      specialPrice: "",
      promoStartDate: null,
      promoEndDate: null,
      stockQuantity: "",
      sellerSku: "",
      variants: [],
    },
    validationSchema: () => {
      return Yup.object({
        subCategoryId: Yup.number().required("Sub Category Required"),
        categoryId: Yup.number().required("Category Required"),
        status: Yup.boolean().required("Status Required"),
        price: Yup.number().required("Price Required"),
        title: Yup.string().required("Product Title Required"),
        articleName: Yup.string().required("Article Number Required"),
        description: Yup.string().required("Description Required"),
        samePrice: Yup.boolean(),
        varient: validateVarient
          ? Yup.object().shape({
              ...varientOptionsValidation,
              purchasePrice: Yup.number().required(
                "Purchase Price is required"
              ),
              price: Yup.number().required("Price is required"),
              discount: Yup.number().required("Discount is required"),
            })
          : Yup.object(),
        varients:
          formik.values.varients?.length === 0 && !validateVarient
            ? Yup.array()
                .required("At least one varient is required")
                .min(1, "At least one varient is required")
            : Yup.array(),
        images:
          formik.values.allImages?.length === 0
            ? Yup.array()
                .required("At least one image is required")
                .min(1, "At least one image is required")
                .max(5, "Maximum 5 images allowed")
                .of(
                  Yup.mixed()
                    .test(
                      "fileFormat",
                      "Invalid file format. Please upload an image file (PNG, JPG, JPEG).",
                      (value) => {
                        // Ensure the value is a File object
                        if (value instanceof File) {
                          // Check the file type
                          return (
                            value.type === "image/png" ||
                            value.type === "image/jpeg" ||
                            value.type === "image/jpg"
                          );
                        }
                        return false;
                      }
                    )
                    .test(
                      "fileSize",
                      "Image size should not exceed 10 MB.",
                      (value) => {
                        // Ensure the value is a File object
                        if (value instanceof File) {
                          // Check the file size
                          return value.size <= 10 * 1024 * 1024; // 10 MB in bytes
                        }
                        return false;
                      }
                    )
                )
            : Yup.array()
                .max(5, "Maximum 5 images allowed")
                .of(
                  Yup.mixed()
                    .test(
                      "fileFormat",
                      "Invalid file format. Please upload an image file (PNG, JPG, JPEG).",
                      (value) => {
                        // Ensure the value is a File object
                        if (value instanceof File) {
                          // Check the file type
                          return (
                            value.type === "image/png" ||
                            value.type === "image/jpeg" ||
                            value.type === "image/jpg"
                          );
                        }
                        return false;
                      }
                    )
                    .test(
                      "fileSize",
                      "Image size should not exceed 10 MB.",
                      (value) => {
                        // Ensure the value is a File object
                        if (value instanceof File) {
                          // Check the file size
                          return value.size <= 10 * 1024 * 1024; // 10 MB in bytes
                        }
                        return false;
                      }
                    )
                ),
        // Add video validation (optional, simple)
        productYoutubeLink: Yup.string().url("Invalid YouTube URL").nullable(),
        // Add brand and what's in box validation (make optional)
        brand: Yup.string().nullable(),
        whatsInBox: Yup.string().nullable(),
        // Add validation for weight and dimensions (make optional)
        productWeightValue: Yup.number().min(0.001, "Min 0.001").nullable(),
        productWeightUnit: Yup.string().oneOf(["kg", "g"]).nullable(),
        packageLength: Yup.number().min(0.01, "Min 0.01cm").nullable(),
        packageWidth: Yup.number().min(0.01, "Min 0.01cm").nullable(),
        packageHeight: Yup.number().min(0.01, "Min 0.01cm").nullable(),
        dangerousGoods: Yup.string().nullable(),
        warrantyType: Yup.string().oneOf(["no", "seller", "brand"]).nullable(),
        // Add validation for price, stock, sku, variants (make optional)
        standardPrice: Yup.number().min(0, "Min 0").nullable(),
        specialPrice: Yup.number().min(0, "Min 0").nullable(),
        // promoStartDate: Yup.date().nullable().when('specialPrice', {
        //   is: v => !!v,
        //   then: s => s.required('Required'),
        //   otherwise: s => s.nullable()
        // }),
        // promoEndDate: Yup.date().nullable().when('specialPrice', {
        //   is: v => !!v,
        //   then: s => s.required('Required'),
        //   otherwise: s => s.nullable()
        // }),
        stockQuantity: Yup.number().min(0, "Min 0").nullable(),
        sellerSku: Yup.string().nullable(),
        variants: Yup.array(),
      });
    },

    onSubmit: async (values) => {
      console.log("Form submitted! Values:", values);
      console.log("Form errors:", formik.errors);
      console.log("Form is valid:", formik.isValid);

      const formData = new FormData();
      console.log(values);
      if (values?.images.length > 5) {
        toast.error("Please upload up to 5 images.");
        return;
      }

      // Append individual fields to the FormData object
      formData.append("title", values.title);
      formData.append("titleUrdu", values.titleUrdu || "");
      formData.append("articleName", values.articleName);
      formData.append("description", values.description);
      formData.append("highlights", values.highlights);
      formData.append("status", values.status);
      formData.append("purchasePrice", values.purchasePrice);
      formData.append("price", values.price);
      formData.append("discount", values.discount);
      formData.append("subCategoryId", values.subCategoryId);
      formData.append("categoryId", values.categoryId);
      formData.append("samePrice", values.samePrice);
      formData.append("samePurchasePrice", values.samePurchasePrice);
      formData.append("sameDiscount", values.sameDiscount);
      formData.append("userId", values.userId);

      // Add brand and what's in box to form data
      formData.append("brand", values.brand);
      formData.append("whatsInBox", values.whatsInBox);

      // Add weight, dimensions, dangerous goods
      formData.append("productWeightValue", values.productWeightValue);
      formData.append("productWeightUnit", values.productWeightUnit);
      formData.append("packageLength", values.packageLength);
      formData.append("packageWidth", values.packageWidth);
      formData.append("packageHeight", values.packageHeight);
      formData.append("dangerousGoods", values.dangerousGoods);
      formData.append("warrantyType", values.warrantyType);

      // Add price, stock, sku, variants
      formData.append("standardPrice", values.standardPrice);
      formData.append("specialPrice", values.specialPrice);
      formData.append("promoStartDate", values.promoStartDate);
      formData.append("promoEndDate", values.promoEndDate);
      formData.append("stockQuantity", values.stockQuantity);
      formData.append("sellerSku", values.sellerSku);
      formData.append("showOnFrontpage", values.showOnFrontpage);
      formData.append("isFeatured", values.isFeatured);
      formData.append("isCollection", values.isCollection);

      // Add video support
      if (values.productVideo && values.videoOption === "upload") {
        formData.append("productVideo", values.productVideo);
      }
      if (values.productYoutubeLink && values.videoOption === "youtube") {
        formData.append("productYoutubeLink", values.productYoutubeLink);
      }

      // Add existing images
      if (values.allImages && values.allImages.length > 0) {
        formData.append("allImages", JSON.stringify(values.allImages));
      }

      // Add new images
      if (values.images && values.images.length > 0) {
        values.images.forEach((file, index) => {
          formData.append(`images`, file);
        });
      }

      // Function to recursively append object properties to FormData
      const appendObjectToFormData = (obj, formData, prefix = "") => {
        for (const key in obj) {
          const value = obj[key];
          const newKey = prefix ? `${prefix}[${key}]` : key;

          if (
            typeof value === "object" &&
            value !== null &&
            !Array.isArray(value)
          ) {
            appendObjectToFormData(value, formData, newKey);
          } else if (Array.isArray(value)) {
            // Handle arrays properly
            value.forEach((item, index) => {
              if (typeof item === "object" && item !== null) {
                appendObjectToFormData(item, formData, `${newKey}[${index}]`);
              } else {
                formData.append(`${newKey}[${index}]`, item);
              }
            });
          } else {
            formData.append(newKey, value);
          }
        }
      };

      // Append each variant to FormData
      if (values.varients && values.varients.length > 0) {
        values.varients.forEach((variant, index) => {
          appendObjectToFormData(variant, formData, `varients[${index}]`);
        });
      }

      if (specificProduct) {
        dispatch(updateProduct(formData, productId)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch({ type: RESET_SPECIFIC_PRODUCT });
            dispatch(getProducts());
            navigate("/products");
          }
        });
      } else {
        dispatch(addProduct(formData)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getProducts());
            navigate("/products");
          }
        });
      }
    },
  });

  const removeVarient = (varientId) => {
    formik.setValues((prevValues) => {
      const updatedVarients = prevValues.varients.filter(
        (varient) => varient.id !== varientId
      );
      return { ...prevValues, varients: updatedVarients };
    });
  };

  useEffect(() => {
    if (formik?.values?.samePrice) {
      formik.setValues({
        ...formik.values,
        varient: {
          ...formik.values.varient,
          price: formik?.values?.price,
        },
      });
    } else {
      formik.setValues({
        ...formik.values,
        price: 0,
      });
    }
  }, [formik?.values?.samePrice, formik?.values?.price]);

  useEffect(() => {
    if (formik?.values?.samePurchasePrice) {
      formik.setValues({
        ...formik.values,
        varient: {
          ...formik.values.varient,
          purchasePrice: formik?.values?.purchasePrice,
        },
      });
    } else {
      formik.setValues({
        ...formik.values,
        purchasePrice: 0,
      });
    }
  }, [formik?.values?.samePurchasePrice, formik?.values?.purchasePrice]);

  useEffect(() => {
    if (formik?.values?.sameDiscount) {
      formik.setValues({
        ...formik.values,
        varient: {
          ...formik.values.varient,
          discount: formik?.values?.discount,
        },
      });
    } else {
      formik.setValues({
        ...formik.values,
        discount: 0,
      });
    }
  }, [formik?.values?.sameDiscount, formik?.values?.discount]);

  useEffect(() => {
    if (varientOptions?.length > 0) {
      varientOptions.map((option) => {
        formik.initialValues.varient = {
          ...formik.initialValues.varient,
          [option.label]: "",
        };
      });
    }
  }, [varientOptions]);

  useEffect(() => {
    if (formik.values.categoryId) {
      const filter = subCategories.filter(
        (item) => item.category_id === formik.values.categoryId
      );

      if (filter) {
        setFilterSubCategories(filter);
      }
    }
  }, [formik.values.categoryId]);

  useEffect(() => {
    if (user) {
      dispatch(getCategory());
      dispatch(getSubCategory());
      dispatch(getVarientOption());
      dispatch(getOptionValues());
    }
  }, []);
  useEffect(() => {
    if (productId) {
      dispatch(getspecificProduct(productId));
    } else {
      formik.resetForm();
      dispatch({ type: RESET_SPECIFIC_PRODUCT });
    }
  }, []);

  useEffect(() => {
    dispatch({ type: RESET_SPECIFIC_PRODUCT });
    formik.resetForm();
  }, [location.pathname]);

  useEffect(() => {
    if (Array.isArray(varientOptions) && varientOptions.length > 0) {
      varientOptions.forEach((option) => {
        formik.initialValues.varient = {
          ...formik.initialValues.varient,
          [option.label]: "",
        };
      });
    }
  }, [varientOptions]);

  // Auto-select subcategory and category based on product title and subcategory suggestions
  useEffect(() => {
    const title = formik.values.title?.trim().toLowerCase();
    if (!title || !subCategories?.length) return;

    // Find a subcategory whose suggestions include the title
    const matchedSub = subCategories.find((sub) => {
      let suggestions = sub.suggestions;
      if (typeof suggestions === "string") {
        try {
          suggestions = JSON.parse(suggestions);
        } catch (e) {
          suggestions = [];
        }
      }
      return (
        Array.isArray(suggestions) &&
        suggestions.some((kw) => kw.toLowerCase() === title)
      );
    });
    if (matchedSub) {
      // Only update if not already selected
      if (
        formik.values.subCategoryId !== matchedSub.id ||
        formik.values.categoryId !== matchedSub.category_id
      ) {
        formik.setFieldValue("categoryId", matchedSub.category_id);
        formik.setFieldValue("subCategoryId", matchedSub.id);
      }
    }
  }, [formik.values.title, subCategories]);

  // Brand dropdown state
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandLoading, setBrandLoading] = useState(false);
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");

  // Fetch brands on mount
  useEffect(() => {
    const fetchBrands = async () => {
      setBrandLoading(true);
      const res = await dispatch(getProductBrands());
      let brands = [];
      if (res && Array.isArray(res)) {
        brands = res.map((b) => ({ label: b.name, value: b.id }));
      } else if (res && Array.isArray(res.data)) {
        brands = res.data.map((b) => ({ label: b.name, value: b.id }));
      }
      brands.unshift({ label: "No Brand", value: "no-brand" });
      brands.push({ label: "Add New Brand", value: "add-new" });
      setBrandOptions(brands);
      setBrandLoading(false);
    };
    fetchBrands();
  }, [dispatch]);

  // Fetch media images for Media Center
  useEffect(() => {
    const fetchMediaImages = async () => {
      try {
        // Call the API to get all product images
        const response = await dispatch(getAllProductImages());

        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          // Map the response into the proper format for Media Center
          const transformedImages = response.data.map((item) => {
            return {
              id: item.id || Math.random().toString(),
              image: item.image,
              image_path: response.image_path,
              url: response.image_path + item.image,
            };
          });

          setMediaImages(transformedImages);
        } else {
          setMediaImages([]); // Empty array - will show "No images available"
        }
      } catch (error) {
        console.log("Error fetching from API:", error);
        setMediaImages([]); // Empty array - will show "No images available"
      }
    };
    fetchMediaImages();
  }, [dispatch]);

  // Media Center integration
  const handleMediaCenterSelect = (selectedItems) => {
    console.log("handleMediaCenterSelect called with:", selectedItems);

    if (selectedItems && selectedItems.length > 0) {
      // Get the Quill editor instance using ref
      console.log("quillRef.current:", quillRef.current);

      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        console.log("quill instance:", quill);

        if (quill) {
          // Get current cursor position
          const range = quill.getSelection();
          const index = range ? range.index : quill.getLength();
          console.log("Inserting at index:", index);

          // Insert each selected image
          selectedItems.forEach((item) => {
            console.log("Inserting image:", item.url);
            // Insert image at cursor position
            quill.insertEmbed(index, "image", item.url);
            // Add a line break after the image
            quill.insertText(index + 1, "\n");
          });
        } else {
          console.log("Quill instance not found");
        }
      } else {
        console.log("quillRef.current is null");
      }
    }
    setIsMediaCenterOpen(false);
  };

  // Content Score calculation
  const contentScore = useMemo(() => {
    let score = 0;
    // Basic Info: title, articleName, categoryId, subCategoryId
    if (
      formik.values.title &&
      formik.values.articleName &&
      formik.values.categoryId &&
      formik.values.subCategoryId
    )
      score += 20;
    // Images
    if (formik.values.images && formik.values.images.length > 0) score += 15;
    // Description
    if (formik.values.description && formik.values.description.length > 20)
      score += 15;
    // Highlights
    if (formik.values.highlights && formik.values.highlights.length > 10)
      score += 10;
    // Weight/Dimensions
    if (
      formik.values.productWeightValue &&
      formik.values.packageLength &&
      formik.values.packageWidth &&
      formik.values.packageHeight
    )
      score += 10;
    // Brand
    if (formik.values.brand) score += 10;
    // Warranty
    if (formik.values.warrantyType && formik.values.warrantyType !== "no")
      score += 10;
    // Dangerous Goods
    if (formik.values.dangerousGoods) score += 5;
    // What's in the Box
    if (formik.values.whatsInBox && formik.values.whatsInBox.length > 5)
      score += 5;
    return Math.min(score, 100);
  }, [formik.values]);

  return (
    <div className="mx-4">
      {/* Content Score Display */}
      <div className="flex items-center gap-4 mb-6">
        <div className="bg-orange-50 border border-orange-200 rounded-lg px-6 py-3 flex items-center gap-4 shadow-sm">
          <span className="text-lg font-semibold text-orange-600">
            Content Score
          </span>
          <span className="text-3xl font-bold text-orange-500">
            {contentScore}
          </span>
          <span className="text-xs text-slate-500">/ 100</span>
        </div>
        <span className="text-slate-500 text-sm">
          Complete more fields to increase your score and improve your product
          listing!
        </span>
      </div>
      <div>
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          className="p-black-btn"
          onClick={() => {
            formik.resetForm();
            dispatch({ type: RESET_SPECIFIC_PRODUCT });
            navigate(-1);
          }}
        />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <AddProductForm
          formik={formik}
          filterSubCategories={filterSubCategories}
        />

        {/* Brand Selection */}
        <div className="my-3">
          <div className="card shadow-md rounded-lg p-4">
            <label className="block font-semibold mb-2">Brand Selection</label>
            <Dropdown
              placeholder="Select Brand"
              value={formik.values.brand}
              onChange={(e) => {
                if (e.value === "add-new") {
                  setShowAddBrand(true);
                } else {
                  setShowAddBrand(false);
                  formik.setFieldValue("brand", e.value);
                }
              }}
              options={brandOptions}
              loading={brandLoading}
              className="w-full"
              optionLabel="label"
              optionValue="value"
            />
            {showAddBrand && (
              <div className="flex gap-2 mt-2">
                <InputText
                  value={newBrandName}
                  onChange={(e) => setNewBrandName(e.target.value)}
                  placeholder="Enter new brand name"
                  className="flex-1"
                />
                <Button
                  label="Add"
                  icon="pi pi-plus"
                  className="p-primary-btn"
                  onClick={async () => {
                    if (!newBrandName.trim()) return;
                    await dispatch(
                      addProductBrand({ brandName: newBrandName.trim() })
                    );
                    // Refetch and select new brand
                    const brandsRes = await dispatch(getProductBrands());
                    let brands = [];
                    if (brandsRes && Array.isArray(brandsRes)) {
                      brands = brandsRes.map((b) => ({
                        label: b.name,
                        value: b.id,
                      }));
                    } else if (brandsRes && Array.isArray(brandsRes.data)) {
                      brands = brandsRes.data.map((b) => ({
                        label: b.name,
                        value: b.id,
                      }));
                    }
                    brands.unshift({ label: "No Brand", value: "no-brand" });
                    brands.push({ label: "Add New Brand", value: "add-new" });
                    setBrandOptions(brands);
                    const newBrand = brands.find(
                      (b) =>
                        b.label.toLowerCase() ===
                        newBrandName.trim().toLowerCase()
                    );
                    if (newBrand) {
                      formik.setFieldValue("brand", newBrand.value);
                    }
                    setShowAddBrand(false);
                    setNewBrandName("");
                  }}
                  type="button"
                />
                <Button
                  label="Cancel"
                  className="p-red-btn"
                  onClick={() => {
                    setShowAddBrand(false);
                    setNewBrandName("");
                  }}
                  type="button"
                />
              </div>
            )}
            {formik.touched?.brand && formik.errors?.brand && (
              <div className="p-error">{formik.errors?.brand}</div>
            )}
          </div>
        </div>

        {/* What's in the Box */}
        <div className="my-3">
          <div className="card shadow-md rounded-lg p-4">
            <label className="block font-semibold mb-2">
              What's in the Box?
            </label>
            <InputTextarea
              value={formik.values.whatsInBox}
              onChange={(e) =>
                formik.setFieldValue("whatsInBox", e.target.value)
              }
              placeholder="e.g., 1 x Phone, 1 x Charger, 1 x User Manual"
              rows={3}
              className="w-full"
            />
            {formik.touched?.whatsInBox && formik.errors?.whatsInBox && (
              <div className="p-error">{formik.errors?.whatsInBox}</div>
            )}
          </div>
        </div>

        {/* Product Description Section */}
        <div className="my-3">
          <div className="card shadow-md rounded-lg p-4">
            <label className="block font-semibold mb-2">
              Product Description
            </label>
            <div className="mb-4">
              <div className="flex items-center justify-between mb-2">
                <label className="block font-medium">Main Description</label>
                <Button
                  label="Media Center"
                  icon="pi pi-images"
                  className="p-button-sm p-button-outlined p-primary-btn"
                  onClick={() => setIsMediaCenterOpen(true)}
                  type="button"
                />
              </div>
              <ReactQuill
                theme="snow"
                value={formik.values.description}
                onChange={(value) => formik.setFieldValue("description", value)}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image"],
                    ["clean"],
                  ],
                }}
                className="bg-white"
                ref={quillRef}
              />
              {formik.touched.description && formik.errors.description && (
                <div className="p-error">{formik.errors.description}</div>
              )}
            </div>
            <div>
              <label className="block font-medium mb-1">Highlights</label>
              <ReactQuill
                theme="snow"
                value={formik.values.highlights}
                onChange={(value) => formik.setFieldValue("highlights", value)}
                modules={{
                  toolbar: [[{ list: "bullet" }]],
                }}
                placeholder="Key features or bullet points"
                className="bg-white"
              />
              {formik.touched.highlights && formik.errors.highlights && (
                <div className="p-error">{formik.errors.highlights}</div>
              )}
            </div>
          </div>
        </div>

        {/* Media Center Modal */}
        <MediaCenterModal
          isOpen={isMediaCenterOpen}
          onClose={() => setIsMediaCenterOpen(false)}
          onConfirm={handleMediaCenterSelect}
          images={mediaImages}
        />

        {/* Product Weight & Dimensions Section */}
        <div className="my-3">
          <div className="card shadow-md rounded-lg p-4">
            <label className="block font-semibold mb-2">
              Package Weight <span className="text-red-500">*</span>
            </label>
            <div className="flex items-center gap-2 mb-4">
              <InputNumber
                value={formik.values.productWeightValue}
                onValueChange={(e) =>
                  formik.setFieldValue("productWeightValue", e.value)
                }
                placeholder="0.001"
                min={0.001}
                step={0.001}
                mode="decimal"
                className="w-40"
                required
              />
              <Dropdown
                value={formik.values.productWeightUnit}
                options={[
                  { label: "kg", value: "kg" },
                  { label: "g", value: "g" },
                ]}
                onChange={(e) =>
                  formik.setFieldValue("productWeightUnit", e.value)
                }
                className="w-20"
              />
            </div>
            <label className="block font-semibold mb-2">
              Package Length(cm) × Width(cm) × Height(cm){" "}
              <span className="text-red-500">*</span>
            </label>
            <div className="text-xs text-slate-500 mb-1">
              How to measure my package dimensions?{" "}
              <button
                type="button"
                className="text-blue-600 hover:underline"
                onClick={() => setShowPackagingInfo((v) => !v)}
              >
                View Example
              </button>
            </div>
            {showPackagingInfo && (
              <div className="bg-blue-50 border border-blue-100 rounded p-3 mb-2 text-slate-700 text-sm">
                Please <b>Include the packaging materials</b> to be used for
                shipment while entering the package weight and dimensions. Do
                note that inaccurate package dimensions may result in additional
                shipping charges or failed delivery.
              </div>
            )}
            <div className="flex items-center gap-2 mb-4">
              <InputNumber
                value={formik.values.packageLength}
                onValueChange={(e) =>
                  formik.setFieldValue("packageLength", e.value)
                }
                placeholder="0.01"
                min={0.01}
                step={0.01}
                mode="decimal"
                className="w-40"
                required
              />
              <span>×</span>
              <InputNumber
                value={formik.values.packageWidth}
                onValueChange={(e) =>
                  formik.setFieldValue("packageWidth", e.value)
                }
                placeholder="0.01"
                min={0.01}
                step={0.01}
                mode="decimal"
                className="w-40"
                required
              />
              <span>×</span>
              <InputNumber
                value={formik.values.packageHeight}
                onValueChange={(e) =>
                  formik.setFieldValue("packageHeight", e.value)
                }
                placeholder="0.01"
                min={0.01}
                step={0.01}
                mode="decimal"
                className="w-40"
                required
              />
            </div>
            <label className="block font-semibold mb-2">Dangerous Goods</label>
            <div className="flex items-center gap-8 mb-2">
              <div className="flex items-center gap-2">
                <RadioButton
                  inputId="dangerousNone"
                  name="dangerousGoods"
                  value="none"
                  checked={formik.values.dangerousGoods === "none"}
                  onChange={(e) =>
                    formik.setFieldValue("dangerousGoods", e.value)
                  }
                  className="align-middle"
                />
                <label
                  htmlFor="dangerousNone"
                  className="text-base font-normal"
                >
                  None
                </label>
              </div>
              <div className="flex items-center gap-2">
                <RadioButton
                  inputId="dangerousBattery"
                  name="dangerousGoods"
                  value="battery"
                  checked={formik.values.dangerousGoods === "battery"}
                  onChange={(e) =>
                    formik.setFieldValue("dangerousGoods", e.value)
                  }
                  className="align-middle"
                />
                <label
                  htmlFor="dangerousBattery"
                  className="text-base font-normal"
                >
                  Contains battery / flammables / liquid
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Warranty Section */}
        <div className="my-3">
          <div className="card shadow-md rounded-lg p-4">
            <label className="block font-semibold mb-2">Warranty</label>
            <Dropdown
              value={formik.values.warrantyType}
              options={[
                { label: "No Warranty", value: "no" },
                { label: "Seller Warranty", value: "seller" },
                { label: "Brand Warranty", value: "brand" },
              ]}
              onChange={(e) => formik.setFieldValue("warrantyType", e.value)}
              className="w-full"
              placeholder="Select Warranty Type"
            />
            {formik.touched.warrantyType && formik.errors.warrantyType && (
              <div className="p-error">{formik.errors.warrantyType}</div>
            )}
          </div>
        </div>

        {/* Old Variant Form and Table */}
        <AddVarientForm
          formik={formik}
          showVarientForm={showVarientForm}
          setShowVarientForm={setShowVarientForm}
          validateVarient={validateVarient}
          setValidateVarient={setValidateVarient}
          editingVarient={editingVarient}
          setEditingVarient={setEditingVarient}
        />
        <div className="my-3">
          <AddProductTable
            varients={formik.values.varients}
            removeVarient={removeVarient}
            editVarient={editVarient}
          />
          {formik.touched?.varients && formik.errors?.varients && (
            <div className="p-error">{formik.errors?.varients}</div>
          )}
        </div>

        <div className="my-3 flex justify-between">
          <div className=" flex gap-3">
            {formik.values.allImages.map((img) => (
              <ProductImage
                key={img.id}
                path={specificProduct?.image_path}
                image={img.image}
                imgId={img.id}
                productId={productId}
              />
            ))}
            <div
              className="grid place-items-center h-24 w-24"
              style={{
                fontSize: "2em",
                borderRadius: "50%",
                backgroundColor: "var(--surface-b)",
                color: "var(--surface-d)",
              }}
            >
              <i className="pi pi-image text-5xl"></i>
            </div>
          </div>
          <div className="justify-end">
            {formik.values.articleName && (
              <div className="flex">
                <div className="  flex flex-col items-center">
                  <div
                    className=" barcode-wrapper"
                    style={{ padding: "10px", backgroundColor: "white" }}
                  >
                    <Barcode
                      value={formik.values.articleName}
                      width={1.5}
                      height={50}
                      fontSize={12}
                      margin={0}
                      displayValue={false}
                      background="white"
                      lineColor="black"
                    />
                  </div>
                  <span className="mt-2 text-sm font-semibold">
                    {formik.values.articleName}
                  </span>
                  <Button
                    type="button"
                    label="Print Barcode"
                    icon="pi pi-print"
                    className="p-button-sm mt-2"
                    onClick={() => {
                      const printWindow = window.open("", "_blank");
                      const barcodeElement =
                        document.querySelector(".barcode-wrapper");
                      const barcodeHTML = barcodeElement.innerHTML;

                      printWindow.document.write(`
                      <html>
                        <head>
                          <title>Print Barcode</title>
                          <style>
                            body { 
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              height: 100vh;
                              margin: 0;
                              background: white;
                            }
                            .barcode-container {
                              text-align: center;
                              padding: 20px;
                            }
                            .barcode-container svg {
                              background: white;
                            }
                            .barcode-container p {
                              margin-top: 10px;
                              font-size: 14px;
                              font-weight: bold;
                            }
                          </style>
                        </head>
                        <body>
                          <div class="barcode-container">
                            ${barcodeHTML}
                            <p>${formik.values.articleName}</p>
                          </div>
                        </body>
                      </html>
                    `);
                      printWindow.document.close();
                      printWindow.print();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="my-3">
          <ManagePicture formik={formik} />
          {/* Product Video Section (PrimeReact) */}
          <div className="my-3">
            <label className="block font-semibold mb-2">Product Video</label>
            <div className="flex gap-4 mb-2">
              <label>
                <input
                  type="radio"
                  name="videoOption"
                  checked={formik.values.videoOption === "upload"}
                  onChange={() => {
                    formik.setFieldValue("videoOption", "upload");
                    formik.setFieldValue("productYoutubeLink", "");
                  }}
                />{" "}
                Upload Video
              </label>
              <label>
                <input
                  type="radio"
                  name="videoOption"
                  checked={formik.values.videoOption === "youtube"}
                  onChange={() => {
                    formik.setFieldValue("videoOption", "youtube");
                    formik.setFieldValue("productVideo", null);
                  }}
                />{" "}
                YouTube Link
              </label>
            </div>
            {formik.values.videoOption === "upload" && (
              <FileUpload
                name="productVideo"
                accept="video/mp4"
                mode="basic"
                maxFileSize={100 * 1024 * 1024} // 100MB
                customUpload
                className="select-video-btn w-full"
                multiple={false}
                uploadHandler={(e) => {
                  const file = e.files[0];
                  if (file) {
                    formik.setFieldValue("productVideo", file);
                  }
                }}
                chooseLabel="Select Video"
                emptyTemplate={
                  <p className="m-0">Drag and drop video here or click</p>
                }
                auto={false}
                showUploadButton={false}
                showCancelButton={false}
                pt={{
                  root: { className: "w-full" },
                  chooseButton: { color: "bg-red-500" },
                  content: { className: "p-2" },
                }}
              />
            )}
            {formik.values.videoOption === "youtube" && (
              <InputText
                className="w-full mt-2"
                placeholder="Paste YouTube URL here"
                value={formik.values.productYoutubeLink}
                onChange={(e) =>
                  formik.setFieldValue("productYoutubeLink", e.target.value)
                }
              />
            )}
          </div>
        </div>

        {/* Display Options */}
        <div className="bg-white rounded-lg shadow-md p-6 mt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Display Options</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
              <Checkbox
                inputId="isFeatured"
                checked={formik.values.isFeatured}
                onChange={(e) => formik.setFieldValue('isFeatured', e.checked)}
                className="p-checkbox"
              />
              <label htmlFor="isFeatured" className="cursor-pointer flex-1">
                <div className="font-semibold text-gray-800">Feature this Product</div>
                <div className="text-sm text-gray-600">Display in "Featured Home Essentials" section on homepage</div>
              </label>
            </div>

            <div className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
              <Checkbox
                inputId="isCollection"
                checked={formik.values.isCollection}
                onChange={(e) => formik.setFieldValue('isCollection', e.checked)}
                className="p-checkbox"
              />
              <label htmlFor="isCollection" className="cursor-pointer flex-1">
                <div className="font-semibold text-gray-800">Include in Collections</div>
                <div className="text-sm text-gray-600">Display in "Discover Our Collections" section on homepage</div>
              </label>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <div className="flex justify-end gap-4">
            <Button
              label="Clear"
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              disabled={showVarientForm}
              onClick={() => {
                dispatch({ type: RESET_SPECIFIC_PRODUCT });
                formik.resetForm();
              }}
            />
            <Button
              label={"Submit"}
              icon="pi pi-check"
              className="p-secondary-btn"
              disabled={showVarientForm}
              type="submit"
              onClick={() => {
                // Handle submit button click
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
